import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { SpecificService } from '@app/services/integrations/specific/specific.service';
import { SPECIFIC_EVENT_NAME, SPECIFIC_WORKSPACE_ID } from '@app/services/integrations/specific/specific.tokens';

export function provideSpecific(workspaceId: string, eventName: string): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: SPECIFIC_WORKSPACE_ID, useValue: workspaceId },
    { provide: SPECIFIC_EVENT_NAME, useValue: eventName },
    SpecificService,
  ]);
}
